<ion-content class="modal-options ion-padding">
  <div class="modal-form-container">
    <h1 class="title">
      {{ "payment-product-modal.title" | translate }}
    </h1>
    <div class="container-body">
      <p class="subtitle">
        {{ "payment-product-modal.subtitle" | translate }}
      </p>
      <div class="card-list">
        @for (paymentType of paymentTypes; track paymentType) {
        <div class="card">
          <div class="icon">
            <img
              [src]="paymentType.icon"
              alt="{{ paymentType.name | translate }}"
            />
          </div>
          <div class="info">
            <h3 class="name">{{ paymentType.name | translate }}</h3>
            <p class="description">{{ paymentType.description | translate }}</p>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</ion-content>
